export const BRAZE_EVENTS = {
  webCartProductAdded: 'web_cart_product_added',
  webProductFavourited: 'web_product_favourited',
  webProductUnfavourited: 'web_product_unfavourited',
  webReferenceViewed: 'web_reference_viewed',
  webModelViewed: 'web_model_viewed',
} as const;
